import { auth } from './firebase.config'
import { apiClient } from './axios.config'

/**
 * Attach Firebase auth headers to every apiClient request. Call once at boot.
 * Sets `Authorization: Bearer <id-token>` and `X-Organization-Id` from the body.
 */
export const setupApiAuthInterceptor = () => {
  apiClient.interceptors.request.use(async (config) => {
    // Best-effort: a failed refresh must not fail public, no-auth requests
    const token = await auth.currentUser?.getIdToken().catch(() => null)
    if (token) {
      config.headers = config.headers ?? {}
      config.headers.Authorization = `Bearer ${token}`
    }

    const body = config.data
    const orgId =
      body != null && typeof body === 'object' && 'organizationId' in body
        ? body['organizationId']
        : undefined
    if (typeof orgId === 'number' && orgId > 0) {
      config.headers = config.headers ?? {}
      config.headers['X-Organization-Id'] = String(orgId)
    }

    return config
  })
}
